import trackerSvg from "/360Tracker.svg";

const Footer = () => {
  return (
    <footer className="w-full bg-white border-t border-[#E6EDEB] py-5 flex flex-col items-center gap-10 overflow-x-hidden">
      <div className="w-full max-w-8xl px-6 md:px-12 lg:px-30 flex flex-col lg:flex-row justify-between items-start gap-5 lg:gap-20">
        <div className="flex flex-col gap-10 max-w-101.5">
          <div className="flex flex-row md:flex-col gap-5">
            <img src={trackerSvg} alt="360 Tracker" className="w-26 h-26" />
            <p className="flex items-center text-base text-[#7C8291] leading-6 font-normal">
              Track repairs, parts, service history, and order status on a
              simple and secure platform.
            </p>
          </div>

          {/* <div className="flex flex-col gap-5">
            <span className="text-lg font-medium text-[#333333]">
              Social Media
            </span>
            <div className="flex items-center gap-2">
              <a
                href="#"
                className="w-8 h-8 bg-[#E6F0FC] rounded-md flex items-center justify-center hover:bg-blue-100 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-[#0064E0]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    stroke-width="1.5"
                  ></rect>
                  <path
                    d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"
                    stroke-width="1.5"
                  ></path>
                  <line
                    x1="17.5"
                    y1="6.5"
                    x2="17.51"
                    y2="6.5"
                    stroke-width="1.5"
                  ></line>
                </svg>
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-[#E6F0FC] rounded-md flex items-center justify-center hover:bg-blue-100 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-[#0064E0]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"
                    stroke-width="1.5"
                  ></path>
                  <rect
                    x="2"
                    y="9"
                    width="4"
                    height="12"
                    stroke-width="1.5"
                  ></rect>
                  <circle cx="4" cy="4" r="2" stroke-width="1.5"></circle>
                </svg>
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-[#E6F0FC] rounded-md flex items-center justify-center hover:bg-blue-100 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-[#0064E0]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M4 4l11.733 16h4.267l-11.733-16zM4 20l6.768-6.768m2.46-2.46L20 4"
                    stroke-width="1.5"
                  ></path>
                </svg>
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-[#E6F0FC] rounded-md flex items-center justify-center hover:bg-blue-100 transition-colors"
              >
                <svg
                  className="w-5 h-5 text-[#0064E0]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"
                    stroke-width="1.5"
                  ></path>
                </svg>
              </a>
            </div>
          </div> */}
        </div>

        <div className="flex flex-row flex-wrap gap-10 md:gap-18">
          <div className="flex flex-col gap-5 md:min-w-29">
            <h3 className="text-lg font-medium text-[#333333]">Quick Links</h3>
            <ul className="flex flex-col gap-2.5">
              <li>
                <a
                  href="#how-it-works"
                  className="text-sm text-[#7C8291] hover:text-[#0064E0] transition-colors"
                >
                  How It Works
                </a>
              </li>
              <li>
                <a
                  href="#advantages"
                  className="text-sm text-[#7C8291] hover:text-[#0064E0] transition-colors"
                >
                  Advantages
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-sm text-[#7C8291] hover:text-[#0064E0] transition-colors"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-5 md:min-w-56.5">
            <h3 className="text-lg font-medium text-[#333333]">Contact us</h3>

            <ul className="flex flex-col gap-2.5">
              <li className="text-sm text-[#7C8291]">
                <span className="font-medium text-[#333333]">Phone:</span>{" "}
                <a href="tel:+18322608626" className="hover:underline">
                  +1 (832) 260-8626
                </a>
              </li>

              <li className="text-sm text-[#7C8291]">
                <span className="font-medium text-[#333333]">Phone:</span>{" "}
                <a href="tel:+15128086400" className="hover:underline">
                  +1 (512) 808-6400
                </a>
              </li>

              <li className="text-sm text-[#7C8291]">
                <span className="font-medium text-[#333333]">Email:</span>{" "}
                <a
                  href="mailto:info@360servicetracker.com"
                  className="hover:underline"
                >
                  info@360servicetracker.com
                </a>
              </li>

              <li className="text-sm text-[#7C8291]">
                <span className="font-medium text-[#333333]">Location:</span>{" "}
                <a
                  href="https://www.google.com/maps?q=Austin,Texas"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Austin, Texas, USA
                </a>
              </li>

              <li className="text-sm text-[#7C8291]">
                <span className="font-medium text-[#333333]">
                  Business Hours:
                </span>{" "}
                Monday – Friday, 9:00 AM – 5:00 PM (CST)
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-center gap-4">
        <div className="w-full h-px bg-[#EFEFF1]"></div>
        <div className="flex items-center gap-2 py-4">
          <svg
            className="w-6 h-6 text-[#9196A3]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="9" stroke-width="1.5"></circle>
            <path d="M14.5 9.5a3.5 3.5 0 100 5" stroke-width="1.5"></path>
          </svg>
          <p className="text-sm text-[#9196A3] font-normal">
            2026 360ServiceTracker. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
